export const createInfractionService = (fetch) => async (infraction) => {
  try {
    const response = await fetch({
      url: "/api/v1/infracciones",
      method: "post",
      body: infraction,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
